var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#E6ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9412 18H23.4656C21.8157 18 20.5 19.3429 20.5 20.9656V34.8404C20.5 36.4903 21.8429 37.806 23.4656 37.806H32.3882C34.0381 37.806 35.3538 36.4631 35.3538 34.8404V24.1824L27.9126 18H27.9412ZM23.4099 24.2095H26.0957C26.4039 24.2095 26.6552 24.4609 26.6552 24.769C26.6552 25.0771 26.4039 25.3284 26.0957 25.3284H23.4099C23.1018 25.3284 22.8505 25.0771 22.8505 24.769C22.8505 24.4609 23.1018 24.2095 23.4099 24.2095ZM31.9971 34.5867H23.4099C23.1018 34.5867 22.8505 34.3354 22.8505 34.0272C22.8505 33.7191 23.1018 33.4678 23.4099 33.4678H31.9971C32.3053 33.4678 32.5566 33.7191 32.5566 34.0272C32.5566 34.3354 32.3053 34.5867 31.9971 34.5867ZM22.8505 30.9503C22.8505 30.6421 23.1018 30.3908 23.4099 30.3908H31.6903C31.9984 30.3908 32.2497 30.6422 32.2497 30.9503C32.2497 31.2584 31.9984 31.5097 31.6903 31.5097H23.4099C23.1018 31.5097 22.8505 31.2584 22.8505 30.9503ZM32.4724 28.4055H23.4371C23.1289 28.4055 22.8776 28.1542 22.8776 27.846C22.8776 27.5379 23.129 27.2866 23.4371 27.2866H32.4724C32.7805 27.2866 33.0318 27.5379 33.0318 27.846C33.0318 28.1542 32.7805 28.4055 32.4724 28.4055Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.654c66a98fe877ea26da317a033c0503.svg";
export { ForwardRef as ReactComponent };